"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateWaiter = exports.useCreateWaiter = exports.useFetchWaiters = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const waiterAction_1 = require("./waiterAction");
const useFetchWaiters = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const fetchWaitersLoading = (0, react_redux_1.useSelector)((state) => state['waiters/fetch'].loading);
    const fetchWaitersData = (0, react_redux_1.useSelector)((state) => state['waiters/fetch'].data);
    const fetchWaitersError = (0, react_redux_1.useSelector)((state) => state['waiters/fetch'].error);
    const fetchWaiters = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            yield dispatch((0, waiterAction_1.fetch)(payload));
        }
        catch (error) {
            throw new Error("Failed to fetch waiters");
        }
    });
    return {
        fetchWaitersLoading,
        fetchWaitersData,
        fetchWaitersError,
        fetchWaiters
    };
};
exports.useFetchWaiters = useFetchWaiters;
const useCreateWaiter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const createWaiterLoading = (0, react_redux_1.useSelector)((state) => state['waiters/create'].loading);
    const createWaiterData = (0, react_redux_1.useSelector)((state) => state['waiters/create'].data);
    const createWaiterError = (0, react_redux_1.useSelector)((state) => state['waiters/create'].error);
    const createWaiter = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, waiterAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to create waiter");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createWaiterLoading,
        createWaiterData,
        createWaiterError,
        createWaiter
    };
};
exports.useCreateWaiter = useCreateWaiter;
const useUpdateWaiter = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const updateWaiterLoading = (0, react_redux_1.useSelector)((state) => state['waiters/update'].loading);
    const updateWaiterData = (0, react_redux_1.useSelector)((state) => state['waiters/update'].data);
    const updateWaiterError = (0, react_redux_1.useSelector)((state) => state['waiters/update'].error);
    const updateWaiter = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, waiterAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Failed to update waiter");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateWaiterLoading,
        updateWaiterData,
        updateWaiterError,
        updateWaiter
    };
};
exports.useUpdateWaiter = useUpdateWaiter;
